export default {
  pieAttrs: { radius: 80, height: 180, width: 250, innerRadius: 50 },
  minDate: '2008-01-01 00:00:00',
  maxDate: '2024-12-31 23:59:59',
  ndx: null,
  computed: {
    charts() {
      return Object.keys(this.$refs).filter(c => c.match(/chart$/i));
    },
    minYear() {
      return +this.$options.minDate.split('-')[0];
    },
    maxYear() {
      return +this.$options.maxDate.split('-')[0];
    }
  },
  methods: {
    filterRegionTime(args) {
      let data = []
      if (args.filters.length === 0) {
        data = [...this.$options.originalData]
      } else {
        data = [...this.$options.originalData].filter(d => {
          return args.filters.includes(d.region);
        });
      }

      this.reloadChart(data);
      setTimeout(() => {
        this.$refs.regionTimeChart.updateLabels();
      }, 200);
    },
    resetAll() {
      this.charts.filter(v => v !== 'regionTimeChart')
        .forEach(key => { this.$refs[key].reset(); });
      setTimeout(() => {
        this.$refs.regionTimeChart.reset();
        dc.redrawAll();
      }, 200);
    },
    reloadChart(data = null) {
      this.period = this.$refs.form.form.period;
      const prevInterval = this.interval;
      this.interval = this.$refs.form.form.interval;
      this.$options.ndx.remove();
      if (data) {
        this.$options.ndx.add(this.$_getData(data));
      } else {
        this.$options.ndx.add(this.$_getData([...this.$options.originalData]));
      }
      if (prevInterval !== this.interval) {
        const chart = this.$refs.regionTimeChart.chart;
        chart.svg().remove();
        setTimeout(() => {
          this.$refs.regionTimeChart.createChart(this.$options.ndx);
        }, 100);
      }
      dc.redrawAll();
    },
  }
}
